<i18n
  src="@/locales/views/agro_exporter/production/query_by_provider/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <div>
    <go-back-link :text="$t('labels.go_back_link')" :name="routeName('list_processes')" :params="{
      agro_exporter_id: this.agro_exporter_id
    }"></go-back-link>

    <template v-if="load_general_data">
      <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

      <div class="mt-6 px-4">
        <tabs-container v-model="option_tabs" :with_routing="true" />
      </div>

      <router-view v-if="show_content_tab" :providers="providers" :summary="summary"
        :discarded_motives="discarded_motives" :providers_summary="providers_summary"
        :crop_size_summary="crop_size_summary" :crop_size_packages_summary="crop_size_packages_summary"
        :crop_size_packages_by_months="crop_size_packages_by_months"
        :crop_size_packages_by_weeks="crop_size_packages_by_weeks" :totals_weekly="totals_weekly" :stats="stats">
      </router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/query_by_provider/show_process.js";

export default {
  name: "AEProductionQueryByProviderShowProcess",
  props: ["agro_exporter_process_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      load_data_summary: false,
      load_data_weekly: false,
      load_data_providers: false,
      option_tabs: [],
      agro_exporter_process: {},
      providers: [],
      summary: {},
      discarded_motives: [],
      providers_summary: [],
      crop_size_summary: [],
      crop_size_packages_summary: [],
      crop_size_packages_by_months: {},
      crop_size_packages_by_weeks: {},
      totals_weekly: {},
      stats: { summary: { providers: {} } },
      load_panels: { summary: {}, weekly: {}, providers: {} }
    };
  },
  computed: {
    show_content_tab: function () {
      const route_name = this.$route.name;
      if (
        (route_name == this.routeName("show_process_summary") &&
          this.load_data_summary) ||
        (route_name == this.routeName("show_process_weekly") &&
          this.load_data_weekly) ||
        (route_name == this.routeName("show_process_providers") &&
          this.load_data_providers)
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.loadDataByTab();
      this.load_general_data = true;
    },
    loadDataByTab: async function () {
      if (this.option_tabs[0].current && !this.load_data_summary) {
        await this.fetchSummary();
        await this.fetchDiscardedMotives();
        await this.fetchProvidersSummary();
        await this.fetchCropSizeSummary();
        await this.fetchCropSizePackagesSummary();
        await this.fetchCropSizePackagesByMonths();
        this.load_data_summary = true;
      }
      if (this.option_tabs[1].current && !this.load_data_weekly) {
        await this.fetchTotalsWeekly();
        await this.fetchCropSizePackagesByWeeks();
        this.load_data_weekly = true;
      }
      if (this.option_tabs[2].current && !this.load_data_providers) {
        await this.fetchProviders();
      }
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchProviders: async function () {
      let response = await Requester.fetchProviders(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.providers = response.data;
      this.load_data_providers = true;
    },
    fetchSummary: async function () {
      let response = await Requester.fetchSummary(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.summary = response.data;
      this.load_panels.summary.summary = true;
    },
    fetchTotalsWeekly: async function () {
      let response = await Requester.fetchTotalsWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.totals_weekly = response.data;
    },
    fetchDiscardedMotives: async function () {
      let response = await Requester.fetchDiscardedMotives(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.discarded_motives = response.data;
      this.load_panels.discarded_motives = true;
    },
    fetchProvidersSummary: async function () {
      let response = await Requester.fetchProvidersSummary(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.providers_summary = response.data.providers;
      this.stats.summary.providers = response.data.stats;
      this.load_panels.summary.providers = true;
    },
    fetchCropSizeSummary: async function () {
      let response = await Requester.fetchCropSizeSummary(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.crop_size_summary = response.data;
      this.load_panels.summary.crop_sizes = true;
    },
    fetchCropSizePackagesSummary: async function () {
      let response = await Requester.fetchCropSizePackagesSummary(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.crop_size_packages_summary = response.data;
      this.load_panels.crop_size_packages = response.data;
    },
    fetchCropSizePackagesByMonths: async function () {
      let response = await Requester.fetchCropSizePackagesByMonths(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.crop_size_packages_by_months = response.data;
      this.load_panels.crop_size_packages_by_months = true;
    },
    fetchCropSizePackagesByWeeks: async function () {
      let response = await Requester.fetchCropSizePackagesByWeeks(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.crop_size_packages_by_weeks = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.tabs.summary"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_summary") },
          current: this.$route.name == this.routeName("show_process_summary")
        },
        {
          name: this.$t("labels.tabs.weekly"),
          icon: "fa-solid fa-chart-line",
          route: { name: this.routeName("show_process_weekly") },
          current: this.$route.name == this.routeName("show_process_weekly")
        },
        {
          name: this.$t("labels.tabs.providers"),
          icon: "fa-solid fa-users",
          route: { name: this.routeName("show_process_providers") },
          current: this.$route.name == this.routeName("show_process_providers")
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fillOptions();
        this.fetchData();
      })
    );
  },
  watch: {
    option_tabs() {
      this.loadDataByTab();
    }
  }
};
</script>
